var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.79119 24.4399H0.74486V8.18914H5.79119V24.4399ZM3.26592 5.97292C1.65262 5.97292 0.343506 4.63635 0.343506 3.02268C0.343506 1.40901 1.65262 0.0996094 3.26592 0.0996094C4.87923 0.0996094 6.18834 1.40901 6.18834 3.02268C6.18834 4.63635 4.87923 5.97292 3.26592 5.97292ZM24.6782 24.4406H19.6427V16.5299C19.6427 14.6446 19.6047 12.2268 17.0191 12.2268C14.3954 12.2268 13.9934 14.2751 13.9934 16.3941V24.4406H8.95254V8.1899H13.7925V10.4066H13.8631C14.5366 9.12984 16.1825 7.78241 18.6378 7.78241C23.7439 7.78241 24.6836 11.1456 24.6836 15.5139V24.4406H24.6782Z","fill":"currentColor"}));
}

Linkedin.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
